let RightsConstant = /** @class */ (() => {
    class RightsConstant {
    }
    RightsConstant.Dashboard = class {
        static BasicPrivilege() {
            return "a9657516-c468-4949-ac06-3e00f3920776";
        }
    };
    RightsConstant.Users = class {
        static CanView() {
            return "e21d1429-10bd-4fec-8bdf-049f49228342";
        }
        static CanEdit() {
            return "58fad25a-77b8-4f2f-853a-484aeacba03c";
        }
        static BasicPrivilege() {
            return "6f6b3cf2-04c0-49ac-9ab2-63260916b7b6";
        }
        static CanAdd() {
            return "48206897-0da4-43a7-8af8-a8798aba9ae6";
        }
    };
    RightsConstant.RoleManager = class {
        static BasicPrivilege() {
            return "2cc2acf4-70eb-45b1-a785-82aa29cd9433";
        }
    };
    RightsConstant.UserLogins = class {
        static BasicPrivilege() {
            return "44d60d4c-51ad-453f-8772-04c65d2439e5";
        }
    };
    RightsConstant.ListManager = class {
        static BasicPrivilege() {
            return "4b750ee6-cd20-4776-bad0-c225a5f18419";
        }
    };
    RightsConstant.Notification = class {
        static BasicPrivilege() {
            return "1c7e2222-ac00-4edd-beca-cd705204d93b";
        }
    };
    RightsConstant.PageManager = class {
        static BasicPrivilege() {
            return "1d770ee7-7af7-4a61-b7b2-7de1d51fe291";
        }
    };
    RightsConstant.MenuManager = class {
        static BasicPrivilege() {
            return "9eb7217b-2dcb-4b07-86b3-35cac91df9c8";
        }
    };
    RightsConstant.ScriptManager = class {
        static BasicPrivilege() {
            return "a651fbb2-76f6-4117-b469-a63c49cb5d6b";
        }
    };
    RightsConstant.Categories = class {
        static BasicPrivilege() {
            return "b31035fd-e808-456b-b179-a31c38722dde";
        }
    };
    RightsConstant.Tags = class {
        static BasicPrivilege() {
            return "4e57ba9e-4b46-42ad-a484-5058f4fe9c8f";
        }
    };
    RightsConstant.States = class {
        static BasicPrivilege() {
            return "6db17d74-b394-41d1-87f7-794801c8d859";
        }
    };
    RightsConstant.Entries = class {
        static BasicPrivilege() {
            return "63c5ea55-6a6c-4e14-8e58-84f40ef72d0c";
        }
    };
    RightsConstant.Entry = class {
        static isLegistative() {
            return "201da077-132c-49ab-8042-0d53f7365c4d";
        }
    };
    RightsConstant.Highlights = class {
        static BasicPrivilege() {
            return "521e5776-74a7-4bb7-b917-707c1f45987a";
        }
    };
    RightsConstant.HighlightsView = class {
        static BasicPrivilege() {
            return "ed16c9e0-562b-4a8d-af3b-8939716c524d";
        }
    };
    RightsConstant.CalendarEvents = class {
        static BasicPrivilege() {
            return "fb09522f-aa1a-444d-b6ba-68cff48b9bca";
        }
    };
    RightsConstant.Calendar = class {
        static BasicPrivilege() {
            return "3ef6862a-831c-4e25-9797-9fd34dfa766a";
        }
    };
    RightsConstant.Organizations = class {
        static BasicPrivilege() {
            return "1deecaa7-5eb6-4c1e-9b28-6ee6e3a48f49";
        }
    };
    RightsConstant.FileManager = class {
        static BasicPrivilege() {
            return "2e2fa360-ac51-470b-a2d6-74cc8d925abf";
        }
    };
    RightsConstant.Automations = class {
        static BasicPrivilege() {
            return "e5946624-b766-4e25-b891-73dc71a9943b";
        }
    };
    return RightsConstant;
})();
export { RightsConstant };
